export default __webpack_public_path__ + "static/media/roller4.1dda11fc.gif";